@if (user()) {
    <ion-grid class="chip" (click)="onClicked()">
        <ion-row class="row">
            <ion-col size="auto" class="avatar">
                <mp-user-avatar [user]="user()" [removable]="!disabled() && removable()" [selected]="selected()" (removed)="onRemoved(user().id)"></mp-user-avatar>
            </ion-col>
            <ion-col class="text">
                <div class="name" [class.selected-text]="selected()">{{ user().name }}</div>
                @if (detailed()) {
                    <div class="email">{{ user().email }}</div>
                }
            </ion-col>
        </ion-row>
    </ion-grid>
}
